import React from "react";

import { ISafeHTML } from "../models/nominals";

interface IProps {
    html: string | ISafeHTML;
    inline?: boolean;
    className?: string;
    tagName?: React.HTMLElementType;
}

export const RichText = (props: IProps): React.ReactElement => {
    const richTextProps = {
        className: props.className
            ? `rich-text ${props.className}`
            : "rich-text",
        dangerouslySetInnerHTML: {
            __html: props.html as string,
        },
    };
    let tagName: React.HTMLElementType = "div";
    if (props.inline) {
        tagName = "span";
    }
    if (props.tagName) {
        tagName = props.tagName;
    }
    return React.createElement(tagName, richTextProps);
};

export default RichText;
